import React from 'react';
import PropTypes from 'prop-types';

import NoAccess from './NoAccess';
import HasAccess from './HasAccess';

const LoadingState = ({ hasAccess = false }) =>
  hasAccess ? <HasAccess /> : <NoAccess />;

LoadingState.propTypes = {
  hasAccess: PropTypes.bool
};

export default LoadingState;
